









import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { ApexOptions } from 'apexcharts';
import { IRussiaResortRegion } from '../plugins/store.russiaResort';

@Component({})
export default class ResortHistoryChart extends Vue {

	public get series() {
		return [{
			data: this.region.regionHistory,
		}];
	}
	public options: ApexOptions = {
		chart: {
			type: 'area',
			toolbar: {
				show: false,
			},
			zoom: {
				enabled: false,
			},
			width: '150%',
		},
		dataLabels: {
			enabled: false,
		},
		tooltip: {
			y: {
				title: {
					formatter: (val) => {
						return 'Кол-во отдыхающих';
					},
				},
			},
		},
		xaxis: {
			labels: {
				formatter: (val, opts) => {
					if (val) {
						return this!.$options!.filters!.formatDateMonth(val!);
					}
					return val;
				},
			},
		},
	};
	public get region(): IRussiaResortRegion {
		return this.$store.getters['russiaResort/getSelectedRegion'];
	}

}
